/**
 * Item status constants
 * Used for filtering and categorizing user products
 */
export const ITEM_STATUS = {
  // Current status values
  OWNED: 'owned',
  TRACKING: 'tracking',
  REMOVED: 'removed',
  
  // Legacy status values (for backward compatibility)
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  SOLD: 'sold',
} as const;

export type ItemStatus = typeof ITEM_STATUS[keyof typeof ITEM_STATUS];

/**
 * Returns true if the status represents an owned item.
 * Note: Missing (null/undefined) status is NOT treated as owned.
 * This helps identify data integrity issues.
 */
export const isOwnedStatus = (status?: string | null): boolean => {
  return status === ITEM_STATUS.OWNED || status === ITEM_STATUS.ACTIVE;
};

/**
 * Helper to check if a status represents a removed item
 */
export const isRemovedStatus = (status?: string | null): boolean => {
  return status === ITEM_STATUS.REMOVED || 
         status === ITEM_STATUS.ARCHIVED || 
         status === ITEM_STATUS.SOLD;
};

/**
 * Helper to check if a status represents a tracking item
 */
export const isTrackingStatus = (status?: string | null): boolean => {
  return status === ITEM_STATUS.TRACKING;
};
